const mq: MediaQueryList = globalThis.matchMedia("(min-width: 1123px)");
mq.addEventListener("change", () => widthChange(mq));
widthChange(mq);

function widthChange(mq: MediaQueryList) {
    if (mq.matches) {
        // Desktop
        initHorizontalMenuHeights();
    } else {
        // Mobile
        $(".mobile-toggle").on("click", function () {
            const headerNav = $(".header-navigation");
            if (headerNav.hasClass("js-nav-open")) {
                $(".header-navigation").removeClass("js-nav-open");
                $(".js-menu-open").removeClass("js-menu-open");
                $(".page").removeClass("nav-open");
                $("html").removeClass("stop-scrolling");
            } else {
                $(".header-navigation").addClass("js-nav-open");
                $(".page").addClass("nav-open");
                $("html").addClass("stop-scrolling");
            }
        });

        $(".js-nav-item.has-children").on("click", function (e) {
            e.stopPropagation();
            const $this = $(this);
            const $target = $(e.target);
            const $childMenu = $this.find(".nav-menu").first();
            $childMenu.addClass("js-menu-open");
            if ($target.closest(".js-nav-item").hasClass("has-children")) {
                e.preventDefault();
            }
        });

        $(".nav-back").on("click", function (e) {
            e.stopImmediatePropagation();
            const $this = $(this);
            $this.parent(".nav-menu").removeClass("js-menu-open");
        });
    }
}

/** Calculates dynamic heights for horizontal menus based on content and viewport */
function initHorizontalMenuHeights(): void {
    const horizontalMenus = document.querySelectorAll<HTMLElement>(".nav-menu.horizontal-menu");
    if (!horizontalMenus.length) return;

    horizontalMenus.forEach((menu) => {
        const parentNavItem = menu.closest(".nav-item");
        if (!parentNavItem) return;
        parentNavItem.addEventListener("mouseenter", () => calculateAndApplyMenuHeight(menu));
    });

    let resizeTimeout: ReturnType<typeof setTimeout>;
    globalThis.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (mq.matches) {
                horizontalMenus.forEach((menu) => {
                    if (menu.offsetParent !== null) calculateAndApplyMenuHeight(menu);
                });
            }
        }, 100);
    });
}

function calculateAndApplyMenuHeight(menu: HTMLElement): void {
    const itemList = menu.querySelector<HTMLElement>(".item-list");
    if (!itemList) return;

    // Remove max-height to measure natural heights
    itemList.style.setProperty("--nav-menu-height", "none");

    const columns = itemList.querySelectorAll<HTMLElement>(":scope > ul");
    let maxColumnHeight = 0;
    const columnHeights: number[] = [];

    columns.forEach((column) => {
        const items = column.querySelectorAll<HTMLElement>(":scope > li, :scope > span");
        let columnHeight = 0;

        items.forEach((item) => {
            const style = globalThis.getComputedStyle(item);
            const marginTop = Number.parseFloat(style.marginTop) || 0;
            const marginBottom = Number.parseFloat(style.marginBottom) || 0;
            columnHeight += item.offsetHeight + marginTop + marginBottom;
        });

        columnHeights.push(columnHeight);
        if (columnHeight > maxColumnHeight) maxColumnHeight = columnHeight;
    });

    const menuRect = menu.getBoundingClientRect();
    const viewportHeight = globalThis.innerHeight;
    const padding = 48; // Safe area
    const maxAvailableHeight = viewportHeight - menuRect.top - padding;

    const calculatedHeight = calculateOptimalHeight(columnHeights, maxAvailableHeight);
    const minHeight = Math.min(maxColumnHeight, 200);
    const optimalHeight = Math.max(calculatedHeight, minHeight);

    itemList.style.setProperty("--nav-menu-height", `${optimalHeight}px`);

    // Apply height to full-column items
    const fullColumnLists = menu.querySelectorAll<HTMLElement>("ul:not(.item-list):has(li.full-column)");
    fullColumnLists.forEach((ul) => {
        ul.style.height = `${optimalHeight}px`;
    });
}

function calculateOptimalHeight(columnHeights: number[], maxHeight: number): number {
    if (columnHeights.length === 0) return 200;
    if (columnHeights.length === 1) return Math.min(columnHeights[0] ?? 200, maxHeight);

    const maxColumnHeight = Math.max(...columnHeights);
    return Math.min(maxColumnHeight, maxHeight);
}

$(function () {
    if (mq.matches) {
        setTimeout(() => {
            document.querySelectorAll<HTMLElement>(".nav-menu.horizontal-menu").forEach((menu) => {
                calculateAndApplyMenuHeight(menu);
            });
        }, 100);
    }
});
